import {fetchAuthTeam, getPrivateAxios} from '@blesk-frontend/api';
import {bleskAuthStore} from '@blesk-frontend/auth';
import {Loader} from '@blesk-frontend/ui';
import {useEffect, useState} from 'react';
import {toast} from 'sonner';

import {AuthPage} from '@/features/auth';
import {STAFF_SLUG_KEY} from '@/features/auth/hooks';
import {changedTeamHintKey, teamMemberInviteHintKey} from '@/features/team';
import {updateExtensionToken} from '@/libs';
import {Route} from '@/routes/_auth/auth/invite';

export const AuthInvitePage = () => {
  const [inviteFetched, setInviteFetched] = useState(false);
  const {token, updateToken} = bleskAuthStore();
  const {code, accessToken, staffId} = Route.useSearch();
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (staffId === import.meta.env.VITE_INFOSTART_STAFF_ID) {
      window.localStorage.setItem(STAFF_SLUG_KEY, `"${import.meta.env.VITE_INFOSTART_STAFF_ID}"`);
    }

    if (!code) {
      navigate({to: '/'});
    } else if (!token && accessToken) {
      sessionStorage.setItem('inviteCode', code);
      updateToken(accessToken);
    } else if (!token) {
      sessionStorage.setItem('inviteCode', code);
      navigate({to: '/auth/signin', search: {inviteCode: code}});
    } else {
      if (inviteFetched) {
        return;
      }

      getPrivateAxios()
        .get(`teams/invite/${code}`)
        .then(async (response) => {
          setInviteFetched(true);

          const {
            data: {teamId},
          } = await getPrivateAxios().post(`/teams/invite/${code}`);

          const {accessToken} = await fetchAuthTeam({teamId});
          updateToken(accessToken);

          localStorage.setItem(changedTeamHintKey, 'true');
          localStorage.setItem(teamMemberInviteHintKey, 'true');
          sessionStorage.removeItem('inviteCode');

          toast.success(`Вы присоединились к команде ${response.data.team.name}`);
          updateExtensionToken(accessToken);

          await navigate({to: '/'});
        })
        .catch(() => {
          toast.error('Приглашение предназначено для другого пользователя');
          navigate({to: '/'});
        });
    }
  }, [code, accessToken, staffId, navigate, token, updateToken, inviteFetched]);

  return (
    <AuthPage>
      <h1 className="text-center text-title-h1">Приглашение в команду</h1>
      <div className="flex justify-center text-paragraph-sm">
        <Loader size={24} />
      </div>
    </AuthPage>
  );
};
